// extracted by mini-css-extract-plugin
export default {"slider":"Slider__slider--slots-gCBSp","navigation":"Slider__navigation--slots-lPPjB"};